module.exports = __webpack_public_path__ + "eb87eafd6a233b44befd23eba2a600c4.svg";